// Keys (datafield.name) of the datafields a product type needs before bulk copy can be enabled
export const BULK_COPY_REQUIRED_DATAFIELD_KEYS = ['width', 'height'];

export function getDatafieldLabel(datafield) {
    if (!datafield) {
        return null;
    }
    return (
        datafield.label ||
        datafield.name ||
        'Onbekend #' + datafield.datafieldId
    );
}
